var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select_service_wrapper" },
    [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12" }, [
        !_vm.serviceIds.includes(10)
          ? _c("p", { staticClass: "sub-header mr-tp-10" }, [
              _vm._v(" Individual Service Pricings: "),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "row m-0" },
        _vm._l(_vm.plansList, function (service, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "col-lg-12 col-md-12 col-sm-12",
              class: { "mt-40": service.is_bundle && service.id == "13" },
            },
            [
              service.is_bundle && service.id == "13"
                ? _c(
                    "div",
                    {
                      staticClass: "col-lg-12 col-md-12 col-sm-12",
                      class: { "border-line": !_vm.serviceIds.includes(10) },
                    },
                    [_vm._m(0, true)]
                  )
                : _vm._e(),
              service.id != 16
                ? _c(
                    "div",
                    {
                      staticClass: "col-md-12 mr-bt-10 box-border-wrapper",
                      class: {
                        "selected-box":
                          _vm.selectedService(service.id) ||
                          (service.id === 15 &&
                            (_vm.indexOfSelectedService(16) > -1 ||
                              _vm.indexOfSelectedService(15) > -1)),
                        "disable-prod-class":
                          _vm.select_services.length > 1 && service.id == 7,
                      },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        service.id == 9 ||
                        service.id == 10 ||
                        service.id == 13 ||
                        service.id == 14
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-7 col-md-6 col-xs-8 disp-flex",
                                class: {
                                  "col-sm-6":
                                    service.id == 7 ||
                                    service.id == 9 ||
                                    service.id == 10,
                                  "col-sm-5":
                                    service.id == 1 ||
                                    service.id == 2 ||
                                    service.id == 4 ||
                                    service.id == 8,
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.select_services,
                                      expression: "select_services",
                                    },
                                  ],
                                  staticClass: "custom_checkbox",
                                  attrs: {
                                    type: "checkbox",
                                    id: "service_" + service.id,
                                    name: "selectservice",
                                    disabled:
                                      _vm.select_services.length > 1 &&
                                      service.id == 7,
                                  },
                                  domProps: {
                                    value: service,
                                    checked: Array.isArray(_vm.select_services)
                                      ? _vm._i(_vm.select_services, service) >
                                        -1
                                      : _vm.select_services,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.select_services,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = service,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.select_services = $$a.concat(
                                                [$$v]
                                              ))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.select_services = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.select_services = $$c
                                        }
                                      },
                                      function ($event) {
                                        return _vm.emitService(
                                          service.id,
                                          $event
                                        )
                                      },
                                    ],
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "default-label",
                                    attrs: { for: "service_" + service.id },
                                  },
                                  [_vm._v(_vm._s(service.name))]
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-7 col-md-6 col-xs-8 service-names d-flex align-items-center",
                                class: {
                                  "col-sm-6":
                                    service.id == 7 ||
                                    service.id == 9 ||
                                    service.id == 10,
                                  "col-sm-5":
                                    service.id == 1 ||
                                    service.id == 2 ||
                                    service.id == 4,
                                },
                              },
                              [
                                _c("span", { staticClass: "checkbox mr-12" }, [
                                  _c("label", [
                                    service.id !== 15
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.select_services,
                                              expression: "select_services",
                                            },
                                          ],
                                          staticClass: "custom_checkbox",
                                          attrs: {
                                            type: "checkbox",
                                            id: "service_" + service.id,
                                            name: "selectservice",
                                            disabled:
                                              _vm.select_services.length > 1 &&
                                              service.id == 7,
                                          },
                                          domProps: {
                                            value: service,
                                            checked: Array.isArray(
                                              _vm.select_services
                                            )
                                              ? _vm._i(
                                                  _vm.select_services,
                                                  service
                                                ) > -1
                                              : _vm.select_services,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a = _vm.select_services,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = service,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.select_services =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.select_services = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.select_services = $$c
                                                }
                                              },
                                              function ($event) {
                                                return _vm.emitService(
                                                  service.id,
                                                  $event
                                                )
                                              },
                                            ],
                                          },
                                        })
                                      : _c("input", {
                                          staticClass: "custom_checkbox",
                                          attrs: {
                                            type: "checkbox",
                                            id: "service_" + service.id,
                                            name: "selectservice",
                                            value: "true",
                                            disabled:
                                              _vm.select_services.length > 1 &&
                                              service.id == 7,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.regReportMarketSelection ===
                                                15 ||
                                              _vm.regReportMarketSelection ===
                                                16,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.emitService(
                                                service.id,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                    _c("span", { staticClass: "cr" }),
                                  ]),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "default-label",
                                    attrs: { for: "service_" + service.id },
                                  },
                                  [_vm._v(_vm._s(service.name))]
                                ),
                              ]
                            ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-5 col-md-6 col-xs-4 txt-alg-rt",
                            class: {
                              "col-sm-6":
                                service.id == 7 ||
                                service.id == 9 ||
                                service.id == 10,
                              "col-sm-7":
                                service.id == 1 ||
                                service.id == 2 ||
                                service.id == 4 ||
                                service.id == 8,
                            },
                          },
                          [
                            !service.is_bundle &&
                            (service.id == 1 ||
                              service.id == 2 ||
                              service.id == 4 ||
                              service.id == 15)
                              ? _c(
                                  "span",
                                  { staticClass: "free-service hide_xs_view" },
                                  [
                                    _vm._v(
                                      "Free Service: Product Classification "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            service.id !== 2 && service.id !== 14
                              ? _c("span", { staticClass: "default-label" }, [
                                  service.id != "15" &&
                                  !(
                                    _vm.select_services.length > 1 &&
                                    service.id == 7
                                  )
                                    ? _c("span", [
                                        _vm._v("$" + _vm._s(service.price)),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            service.id == 14
                              ? _c("span", { staticClass: "default-label" }, [
                                  _vm.todayDate() > _vm.renewStartDate() &&
                                  _vm.todayDate() < _vm.renewEndDate()
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "text-decoration": "line-through",
                                            },
                                          },
                                          [_vm._v("$2899")]
                                        ),
                                        _c("span", [
                                          _c("span", [
                                            _vm._v(
                                              " $" + _vm._s(service.price)
                                            ),
                                          ]),
                                        ]),
                                      ])
                                    : _c("span", [
                                        _vm._v("$" + _vm._s(service.price)),
                                      ]),
                                ])
                              : _vm._e(),
                            service.id === 2 && _vm.selectedService(2)
                              ? _c("span", { staticClass: "default-label" }, [
                                  _vm.regIntellMarket === "" && _vm.country
                                    ? _c("span", [_vm._v("Free")])
                                    : _vm._e(),
                                  _vm.regIntellMarket === "all"
                                    ? _c("span", [
                                        _c("span", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(service.price) +
                                              " per year"
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _c("span", { staticClass: "disp-flex" }, [
                              service.id === 9 || service.id === 10
                                ? _c("span", [_vm._v(" per use")])
                                : service.id != "15" &&
                                  service.id != 2 &&
                                  !(
                                    _vm.select_services.length > 1 &&
                                    service.id == 7
                                  )
                                ? _c("span", [_vm._v(" per year")])
                                : _vm.select_services.length > 1 &&
                                  service.id == 7
                                ? _c("span", [_vm._v("Free Service")])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "col-xs-12 market-text" }, [
                          service.valid_until &&
                          (_vm.serviceIds.indexOf(service.id) >= 0 ||
                            _vm.serviceIds.indexOf(16) >= 0)
                            ? _c(
                                "div",
                                { staticClass: "col-sm-5 col-xs-12 renews-on" },
                                [
                                  _c("img", {
                                    staticClass: "traingle-alert",
                                    attrs: {
                                      src: "/static/images/icons/alert_triangle.svg",
                                      alt: "alert-icon",
                                    },
                                  }),
                                  _vm._v(
                                    " Expires on " +
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          service.valid_until
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          service.id === 13
                            ? _c(
                                "span",
                                {
                                  staticClass: "col-xs-12 pr-0 txt-alg-rt",
                                  class:
                                    service.valid_until &&
                                    _vm.serviceIds.indexOf(service.id) >= 0
                                      ? "col-sm-7"
                                      : "col-sm-12",
                                },
                                [
                                  _vm._v(
                                    "Includes access to 3 Markets for Regulatory Reports"
                                  ),
                                ]
                              )
                            : service.id === 14
                            ? _c(
                                "span",
                                {
                                  staticClass: "col-xs-12 pr-0 txt-alg-rt",
                                  class:
                                    service.valid_until &&
                                    _vm.serviceIds.indexOf(service.id) >= 0
                                      ? "col-sm-7"
                                      : "col-sm-12",
                                },
                                [
                                  _vm._v(
                                    "Includes access to all Markets for Regulatory Reports"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        !service.is_bundle &&
                        (service.id == 1 ||
                          service.id == 2 ||
                          service.id == 4 ||
                          service.id == 15)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 free-service-pd display_xs_view",
                              },
                              [
                                _c("div", { staticClass: "free-service" }, [
                                  _vm._v(
                                    "Free Service: Product Classification"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      service.id != "4" && service.id != "7"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "pd-lt-28 pd-rt-0 col-lg-12 col-md-12 col-sm-12",
                            },
                            [_c("hr", { staticClass: "box-int-line" })]
                          )
                        : _vm._e(),
                      service.id === 2
                        ? _c("div", { staticClass: "reg-intel" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row bundle-wrapper col-md-12 col-sm-12 pl-0 pr-0",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-12 col-sm-12 col-xs-12",
                                  },
                                  [
                                    _c("div", { staticClass: "row ml-0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-8 col-sm-7 col-xs-12",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-12 d-flex align-items-center xs-p-0",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "checkbox mr-12",
                                                },
                                                [
                                                  _c("label", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.regIntellServiceDefault,
                                                          expression:
                                                            "regIntellServiceDefault",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "checkbox",
                                                        id: "regIntell_service_default",
                                                        name: "regIntellServiceDefault",
                                                        disabled:
                                                          _vm.defaultCountry >
                                                          0,
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.regIntellServiceDefault
                                                        )
                                                          ? _vm._i(
                                                              _vm.regIntellServiceDefault,
                                                              null
                                                            ) > -1
                                                          : _vm.regIntellServiceDefault,
                                                      },
                                                      on: {
                                                        change: [
                                                          function ($event) {
                                                            var $$a =
                                                                _vm.regIntellServiceDefault,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.regIntellServiceDefault =
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ]))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.regIntellServiceDefault =
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                              }
                                                            } else {
                                                              _vm.regIntellServiceDefault =
                                                                $$c
                                                            }
                                                          },
                                                          function ($event) {
                                                            _vm.country = ""
                                                            _vm.emitRegIntellMarketValues()
                                                          },
                                                        ],
                                                      },
                                                    }),
                                                    _c("span", {
                                                      staticClass: "cr",
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    for: "regIntell_service",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " One-time complimentary market "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("div", { staticClass: "row" }, [
                                            service.id === 2 &&
                                            !_vm.defaultCountry
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "market-note",
                                                  },
                                                  [_vm._m(1, true)]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-4 col-sm-5 col-xs-12 service-info pl-0 pr-0",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-12 static-text",
                                            },
                                            [_vm._v("Select Market")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-12" },
                                            [
                                              _c(
                                                "multiselect",
                                                {
                                                  staticClass:
                                                    "multiselect-single-dropdown w-100",
                                                  attrs: {
                                                    disabled:
                                                      _vm.defaultCountry > 0 ||
                                                      !_vm.regIntellServiceDefault,
                                                    showLabels: false,
                                                    "close-on-select": true,
                                                    "allow-empty": false,
                                                    searchable: true,
                                                    options:
                                                      _vm.countryList.map(
                                                        (country) =>
                                                          country.country_name
                                                      ),
                                                    placeholder:
                                                      "Select market",
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.defaultCountryEvent,
                                                  },
                                                  model: {
                                                    value: _vm.country,
                                                    callback: function ($$v) {
                                                      _vm.country = $$v
                                                    },
                                                    expression: "country",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        slot: "noResult",
                                                      },
                                                      slot: "noResult",
                                                    },
                                                    [_vm._v("No matching data")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-12" },
                                            [
                                              _vm.showDefaultErrorMsg &&
                                              _vm.regIntellServiceDefault &&
                                              !_vm.country
                                                ? _c(
                                                    "p",
                                                    { staticClass: "errorMsg" },
                                                    [
                                                      _vm._v(
                                                        " Please select a market "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.showErrorMsg &&
                                              !_vm.regIntellServiceDefault &&
                                              _vm.select_services.length
                                                ? _c(
                                                    "p",
                                                    { staticClass: "errorMsg" },
                                                    [
                                                      _vm._v(
                                                        " Please select Complimentary market "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.showErrorMsg &&
                                              _vm.defaultCountry &&
                                              !_vm.regIntellMarket
                                                ? _c(
                                                    "p",
                                                    { staticClass: "errorMsg" },
                                                    [
                                                      _vm._v(
                                                        " Please select atleast one option "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.showMultipleErrorMsg &&
                                              _vm.regIntellMarket ===
                                                "upgrade" &&
                                              _vm.selectedCountryList.length ===
                                                0
                                                ? _c(
                                                    "p",
                                                    { staticClass: "errorMsg" },
                                                    [
                                                      _vm._v(
                                                        " Please select market(s) "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col-sm-12 col-xs-12 all-markets",
                              },
                              [
                                _c(
                                  "base-radio",
                                  {
                                    attrs: {
                                      id: "regIntell_service_all",
                                      name: "regIntellService",
                                      optionValue: "all",
                                      label: "all",
                                      deselect: true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.uncheck("all")
                                      },
                                      change: function ($event) {
                                        return _vm.regIntellMarketEvent()
                                      },
                                    },
                                    model: {
                                      value: _vm.regIntellMarket,
                                      callback: function ($$v) {
                                        _vm.regIntellMarket = $$v
                                      },
                                      expression: "regIntellMarket",
                                    },
                                  },
                                  [_c("span", [_vm._v(" All markets")])]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      service.id == 13 || service.id == 14
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
                              _vm._m(2, true),
                              _c(
                                "div",
                                { staticClass: "col-sm-9 pl-0 reg-tracker" },
                                [
                                  _c(
                                    "ul",
                                    _vm._l(
                                      service.service_list,
                                      function (services) {
                                        return _c(
                                          "li",
                                          {
                                            key: services,
                                            staticClass: "col-sm-4 pl-0",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "service-info" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "static-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(services)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _vm._m(3, true),
                            ]),
                            _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
                              _vm._m(4, true),
                              _c("div", { staticClass: "row" }, [
                                _vm._m(5, true),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 col-sm-6" },
                                  [
                                    _vm._m(6, true),
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-12 col-sm-12 col-xs-11",
                                        },
                                        [
                                          service.id == 13
                                            ? _c("multiselect", {
                                                staticClass:
                                                  "multiselect-single-dropdown",
                                                attrs: {
                                                  "show-labels": false,
                                                  "allow-empty": false,
                                                  searchable: false,
                                                  options: _vm.options,
                                                  label: "name",
                                                },
                                                on: {
                                                  select:
                                                    _vm.onChangeRecordsEmergoPro,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "singleLabel",
                                                      fn: function (props) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "singleLabel_name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "singleLabel_desc",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .desc
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "option",
                                                      fn: function (props) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option_name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option_desc",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .desc
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.selectedRecordsEmergoPro,
                                                  callback: function ($$v) {
                                                    _vm.selectedRecordsEmergoPro =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedRecordsEmergoPro",
                                                },
                                              })
                                            : _vm._e(),
                                          service.id == 14
                                            ? _c("multiselect", {
                                                staticClass:
                                                  "multiselect-single-dropdown",
                                                attrs: {
                                                  "show-labels": false,
                                                  "allow-empty": false,
                                                  searchable: false,
                                                  options: _vm.options,
                                                  label: "name",
                                                },
                                                on: {
                                                  select:
                                                    _vm.onChangeRecordsEmergoProPlus,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "singleLabel",
                                                      fn: function (props) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "singleLabel_name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "singleLabel_desc",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .desc
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "option",
                                                      fn: function (props) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option_name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option_desc",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .desc
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.selectedRecordsEmergoProPlus,
                                                  callback: function ($$v) {
                                                    _vm.selectedRecordsEmergoProPlus =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedRecordsEmergoProPlus",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.selectedRecords ==
                                          "displayMessage"
                                            ? _c("span", [
                                                _vm._v(
                                                  " You have current limit of more than 5000 records. "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _c("br"),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
                              _vm._m(7, true),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-6 reg-tracker" },
                                  [
                                    _c("ul", [
                                      service.id == 13
                                        ? _c("li", [_vm._m(8, true)])
                                        : _vm._e(),
                                      service.id == 14
                                        ? _c("li", [_vm._m(9, true)])
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                                service.id === 13
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-6" },
                                      [
                                        _vm._m(10, true),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 col-sm-12 col-xs-11",
                                            },
                                            [
                                              _c(
                                                "multiselect",
                                                {
                                                  staticClass:
                                                    "multiselect-single-dropdown multiselect-multiple w-reg-rep-65",
                                                  attrs: {
                                                    showLabels: false,
                                                    "close-on-select": false,
                                                    placeholder:
                                                      "Select Market(s)",
                                                    label: "country_name",
                                                    "track-by": "country_name",
                                                    multiple: true,
                                                    searchable: true,
                                                    "clear-on-select": false,
                                                    options:
                                                      _vm.unsubscribedMarkets,
                                                    value:
                                                      _vm.selectedEmergoProCountryList,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "selection",
                                                        fn: function ({
                                                          values,
                                                          isOpen,
                                                        }) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "selection-count",
                                                            },
                                                            [
                                                              !isOpen
                                                                ? [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "image-size",
                                                                      attrs: {
                                                                        src: "/static/images/icons/filter.svg",
                                                                        alt: "filter-icon",
                                                                      },
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "selected-count",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            values.length
                                                                          ) +
                                                                            " Selected"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : isOpen
                                                                ? [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "image-size",
                                                                      attrs: {
                                                                        src: "/static/images/icons/filter.svg",
                                                                        alt: "filter-icon",
                                                                      },
                                                                    }),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          )
                                                        },
                                                      },
                                                      {
                                                        key: "option",
                                                        fn: function (props) {
                                                          return _c(
                                                            "span",
                                                            {},
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex",
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.updateSelectedCountryList(
                                                                          props.option,
                                                                          "reg-report",
                                                                          "selectedEmergoProCountryList"
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "checkbox inline-checkbox",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  type: "checkbox",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    props.option,
                                                                                  checked:
                                                                                    _vm.selectedEmergoProCountryList.includes(
                                                                                      props.option
                                                                                    ),
                                                                                },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "cr",
                                                                              class:
                                                                                {
                                                                                  "disabled-checkbox":
                                                                                    _vm
                                                                                      .selectedEmergoProCountryList
                                                                                      .length ==
                                                                                    3,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "font-bold":
                                                                          _vm.selectedEmergoProCountryList.includes(
                                                                            props.option
                                                                          ),
                                                                        "font-wt-400":
                                                                          !_vm.selectedEmergoProCountryList.includes(
                                                                            props.option
                                                                          ),
                                                                        "disabled-text":
                                                                          _vm
                                                                            .selectedEmergoProCountryList
                                                                            .length ==
                                                                          3,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.updateSelectedCountryList(
                                                                              props.option,
                                                                              "reg-report",
                                                                              "selectedEmergoProCountryList"
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .country_name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        slot: "noResult",
                                                      },
                                                      slot: "noResult",
                                                    },
                                                    [_vm._v("No matching data")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                service.id === 14
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-6 reg-report-mrkts",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            on: {
                                              click:
                                                _vm.openRegReportCountryPopup,
                                            },
                                          },
                                          [_vm._v("Show Available Markets")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            service.id == 13
                              ? _c(
                                  "div",
                                  { staticClass: "col-sm-12 col-xs-12" },
                                  [_vm._m(11, true)]
                                )
                              : _vm._e(),
                            service.id == 14
                              ? _c(
                                  "div",
                                  { staticClass: "col-sm-12 col-xs-12" },
                                  [_vm._m(12, true), _vm._m(13, true)]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "row" }, [
                        service.id == "1"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-6 col-md-6 col-sm-6 reg-tracker",
                              },
                              [
                                _c("ul", [
                                  service.id == "1"
                                    ? _c("li", [_vm._m(14, true)])
                                    : _vm._e(),
                                  service.id == "1" && _vm.records
                                    ? _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "records-available service-info",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "service-desc" },
                                              [
                                                _vm.records.total_limit >=
                                                  _vm.records.default_limit &&
                                                _vm.records.is_active &&
                                                _vm.todayDate() <=
                                                  _vm.$options.filters.serviceExpDateFormat(
                                                    _vm.records.valid_until
                                                  ) &&
                                                _vm.todayDate() >=
                                                  _vm.$options.filters.serviceExpDateFormat(
                                                    _vm.records.valid_from
                                                  )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.records
                                                              .total_limit -
                                                              _vm.records
                                                                .current_utilization
                                                          ) +
                                                          " of " +
                                                          _vm._s(
                                                            _vm.records
                                                              .total_limit
                                                          ) +
                                                          " available "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.records.is_active &&
                                                _vm.records.total_limit <
                                                  _vm.records.default_limit
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.records
                                                              .default_limit -
                                                              _vm.records
                                                                .current_utilization
                                                          ) +
                                                          " of " +
                                                          _vm._s(
                                                            _vm.records
                                                              .default_limit
                                                          ) +
                                                          " available "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "available-upto static-text",
                                              },
                                              [
                                                _vm._v(
                                                  " (Some options may not be available, adjust the service's current amounts to enable these options.)"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  service.id == "1"
                                    ? _c("li", [_vm._m(15, true)])
                                    : _vm._e(),
                                  service.id == "1"
                                    ? _c("li", [_vm._m(16, true)])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        service.id == "1"
                          ? _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                              _vm._m(17, true),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-12 col-sm-12 col-xs-11",
                                  },
                                  [
                                    _vm.selectedRecords != "displayMessage"
                                      ? _c("multiselect", {
                                          staticClass:
                                            "multiselect-single-dropdown",
                                          attrs: {
                                            "show-labels": false,
                                            "allow-empty": false,
                                            searchable: false,
                                            options: _vm.options,
                                            label: "name",
                                          },
                                          on: { select: _vm.onChangeRecords },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "singleLabel",
                                                fn: function (props) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option_name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option_desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.desc
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "option",
                                                fn: function (props) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option_name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option_desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.desc
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.selectedRecords,
                                            callback: function ($$v) {
                                              _vm.selectedRecords = $$v
                                            },
                                            expression: "selectedRecords",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.selectedRecords == "displayMessage"
                                      ? _c("span", [
                                          _vm._v(
                                            " You have current limit of more than 5000 records. "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c("br"),
                                  ],
                                  1
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      service.id === 9 || service.id === 10
                        ? _c(
                            "div",
                            { staticClass: "row bundle-wrapper mr-tp-10" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-6 col-sm-6 col-xs-12 bundle-third-box",
                                },
                                [
                                  service.id == 9
                                    ? _c(
                                        "p",
                                        { staticClass: "default-label" },
                                        [
                                          _vm._v(
                                            " How many classification rationale reports do you want to generate? "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              service.id !== 10
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-6" },
                                    [
                                      _vm.selectedRecordsProdClsRat !=
                                      "displayMessage"
                                        ? _c("multiselect", {
                                            staticClass:
                                              "multiselect-single-dropdown prod-class-width",
                                            attrs: {
                                              "show-labels": false,
                                              "allow-empty": false,
                                              searchable: false,
                                              options: _vm.options,
                                              label: "name",
                                            },
                                            on: {
                                              select:
                                                _vm.onChangeRecordsProdClsRat,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "singleLabel",
                                                  fn: function (props) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option_name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option_desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.desc
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function (props) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option_name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option_desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.desc
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.selectedRecordsProdClsRat,
                                              callback: function ($$v) {
                                                _vm.selectedRecordsProdClsRat =
                                                  $$v
                                              },
                                              expression:
                                                "selectedRecordsProdClsRat",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("br"),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      service.id === 15
                        ? _c(
                            "div",
                            { staticClass: "row bundle-wrapper mr-tp-10" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-6 col-sm-6 col-xs-12 reg-report",
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("base-radio", {
                                        attrs: {
                                          id: "3markets",
                                          name: "market-types",
                                          optionValue: "15",
                                          disabled:
                                            _vm.select_services.length == 0,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.emitRegReports(15)
                                          },
                                        },
                                        model: {
                                          value: _vm.regReportMarketSelection,
                                          callback: function ($$v) {
                                            _vm.regReportMarketSelection = $$v
                                          },
                                          expression:
                                            "regReportMarketSelection",
                                        },
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "default-label price-info",
                                          attrs: { for: "3markets" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "fw-500" },
                                            [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(service.price) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "per year ( Includes access to 3 Markets )"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._m(18, true),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c("base-radio", {
                                        attrs: {
                                          id: "allMarkets",
                                          name: "market-types",
                                          optionValue: "16",
                                          disabled:
                                            _vm.select_services.length == 0,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.emitRegReports(16)
                                          },
                                        },
                                        model: {
                                          value: _vm.regReportMarketSelection,
                                          callback: function ($$v) {
                                            _vm.regReportMarketSelection = $$v
                                          },
                                          expression:
                                            "regReportMarketSelection",
                                        },
                                      }),
                                      _vm._m(19, true),
                                      _vm._m(20, true),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              service.id == 15
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-6" },
                                    [
                                      _vm._m(21, true),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 col-sm-12 col-xs-11",
                                          },
                                          [
                                            _c(
                                              "multiselect",
                                              {
                                                staticClass:
                                                  "multiselect-single-dropdown multiselect-multiple w-reg-rep-65",
                                                attrs: {
                                                  disabled:
                                                    _vm.regReportMarketSelection ==
                                                    16,
                                                  showLabels: false,
                                                  "close-on-select": false,
                                                  placeholder:
                                                    "Select Market(s)",
                                                  label: "country_name",
                                                  "track-by": "country_name",
                                                  multiple: true,
                                                  searchable: true,
                                                  "clear-on-select": false,
                                                  options:
                                                    _vm.unsubscribedMarkets,
                                                  value:
                                                    _vm.selectedCountryList,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "selection",
                                                      fn: function ({
                                                        values,
                                                        isOpen,
                                                      }) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "selection-count",
                                                          },
                                                          [
                                                            !isOpen
                                                              ? [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "image-size",
                                                                    attrs: {
                                                                      src: "/static/images/icons/filter.svg",
                                                                      alt: "filter-icon",
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "selected-count",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          values.length
                                                                        ) +
                                                                          " Selected"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : isOpen
                                                              ? [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "image-size",
                                                                    attrs: {
                                                                      src: "/static/images/icons/filter.svg",
                                                                      alt: "filter-icon",
                                                                    },
                                                                  }),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        )
                                                      },
                                                    },
                                                    {
                                                      key: "option",
                                                      fn: function (props) {
                                                        return _c("span", {}, [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex",
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateSelectedCountryList(
                                                                      props.option,
                                                                      "reg-report",
                                                                      "selectedCountryList"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "checkbox inline-checkbox",
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        attrs: {
                                                                          type: "checkbox",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              props.option,
                                                                            checked:
                                                                              _vm.selectedCountryList.includes(
                                                                                props.option
                                                                              ),
                                                                          },
                                                                      }
                                                                    ),
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "cr",
                                                                      class: {
                                                                        "disabled-checkbox":
                                                                          _vm
                                                                            .selectedCountryList
                                                                            .length ==
                                                                          3,
                                                                      },
                                                                    }),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "font-bold":
                                                                      _vm.selectedCountryList.includes(
                                                                        props.option
                                                                      ),
                                                                    "font-wt-400":
                                                                      !_vm.selectedCountryList.includes(
                                                                        props.option
                                                                      ),
                                                                    "disabled-text":
                                                                      _vm
                                                                        .selectedCountryList
                                                                        .length ==
                                                                      3,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.updateSelectedCountryList(
                                                                          props.option,
                                                                          "reg-report",
                                                                          "selectedCountryList"
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        props
                                                                          .option
                                                                          .country_name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ])
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "noResult" },
                                                    slot: "noResult",
                                                  },
                                                  [_vm._v("No matching data")]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      service.id === 15
                        ? _c(
                            "div",
                            { staticClass: "col-sm-12 reg-report-mrkts" },
                            [
                              _c(
                                "span",
                                {
                                  on: { click: _vm.openRegReportCountryPopup },
                                },
                                [_vm._v("Show Available Markets")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _vm._m(22),
      _vm.showErrorMsg && _vm.select_services.length === 0
        ? _c("div", { staticClass: "row pl-30 mr-bt-10" }, [
            _c("span", { staticClass: "errorMsg" }, [
              _vm._v("Please select at least one service for renewal."),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "row confirmation-page cnf-sm-border m-0" }, [
        _c(
          "div",
          {
            staticClass:
              "col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected total-price",
          },
          [
            _c("span", { staticClass: "txt-bold" }, [_vm._v("Total ")]),
            _vm._v("(" + _vm._s(_vm.select_services.length) + " Selected) "),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected text-end total-price txt-bold",
          },
          [_vm._v(" $" + _vm._s(_vm.totalPrice) + " ")]
        ),
      ]),
      _c("reg-report-countries-popup", {
        attrs: { countryList: _vm.allMarkets },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "sub-header mr-tp-10 mr-lt-17" }, [
      _c("span", [_vm._v("Emergo Pro & Pro Plus Pricings:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _c("div", { staticClass: "service-info" }, [
          _c("span", { staticClass: "static-text" }, [
            _vm._v(
              " You must also select one free market. This market will remain complimentary, even if your subscription expires"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bundle-sub-heading" }, [
      _c("span", [_vm._v("Services Included :")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "pd-lt-28 pd-rt-0 col-lg-12 col-md-12 col-sm-12" },
      [_c("hr", { staticClass: "box-int-line" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bundle-sub-heading" }, [
      _c("span", [
        _vm._v("Additional Storage and Records for Registration Tracker :"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6 reg-tracker" }, [
      _c("ul", [
        _c("li", [
          _c("div", { staticClass: "service-info" }, [
            _c("span", { staticClass: "service-desc" }, [
              _vm._v(" 250 records & 2GB storage "),
            ]),
            _c("span", { staticClass: "static-text" }, [
              _vm._v(" included in RAMS account purchase"),
            ]),
          ]),
        ]),
        _c("li", [
          _c("div", { staticClass: "service-info" }, [
            _c("span", { staticClass: "static-text" }, [_vm._v("For")]),
            _c("span", { staticClass: "service-desc" }, [
              _vm._v(" 5000+ records,"),
            ]),
            _c("span", { staticClass: "static-text" }, [
              _vm._v(" please contact"),
            ]),
            _c("span", { staticClass: "service-desc" }, [
              _vm._v(" RAMSHelp@ul.com"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12 col-xs-12 bundle-select txt-alg-rt" },
        [
          _c("div", { staticClass: "form-group" }, [
            _vm._v("Registration records and storage upto"),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bundle-sub-heading" }, [
      _c("span", [_vm._v("Includes Markets for Regulatory Reports:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info" }, [
      _c("span", { staticClass: "static-text" }, [_vm._v("Access to")]),
      _c("span", { staticClass: "service-desc" }, [_vm._v(" 3 Markets ")]),
      _c("span", { staticClass: "static-text" }, [
        _vm._v(" included in RAMS account purchase"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info" }, [
      _c("span", { staticClass: "static-text" }, [_vm._v("Access to")]),
      _c("span", { staticClass: "service-desc" }, [_vm._v(" all Markets ")]),
      _c("span", { staticClass: "static-text" }, [
        _vm._v(" included in RAMS account purchase"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 col-xs-12 txt-alg-rt select-mrkt" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._v("Select Markets (Up to 3 markets can be selected)"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bundle-sub-heading" }, [
      _c("span", [_vm._v("Includes 5 team members")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bundle-sub-heading" }, [
      _c("span", [_vm._v("Includes 10 team members")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 reg-tracker" }, [
        _c("ul", [
          _c("li", [
            _c("div", { staticClass: "service-info" }, [
              _c("span", { staticClass: "static-text" }, [
                _vm._v(
                  "Only applicable if account has less than 10 team members at the time of purchase"
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info" }, [
      _c("span", { staticClass: "service-desc" }, [
        _vm._v(" 250 records & 2GB storage "),
      ]),
      _c("span", { staticClass: "static-text" }, [
        _vm._v(" included in RAMS account purchase"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info" }, [
      _c("span", { staticClass: "static-text" }, [
        _vm._v(
          "Some options may not be available, adjust the service's current amounts to enable these options."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info" }, [
      _c("span", { staticClass: "static-text" }, [_vm._v("For")]),
      _c("span", { staticClass: "service-desc" }, [_vm._v(" 5000+ records,")]),
      _c("span", { staticClass: "static-text" }, [_vm._v(" please contact")]),
      _c("span", { staticClass: "service-desc" }, [_vm._v(" RAMSHelp@ul.com")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 col-xs-12 txt-alg-rt" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._v("Registration records and storage upto"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _c("div", { staticClass: "service-info" }, [
          _c("span", { staticClass: "static-text" }, [
            _vm._v("Includes access to Regulatory Reports for up to 3 Markets"),
          ]),
        ]),
      ]),
      _c("li", [
        _c("div", { staticClass: "service-info" }, [
          _c("span", { staticClass: "static-text" }, [
            _vm._v(
              "Markets can also be selected at a later time in the account settings"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "default-label price-info", attrs: { for: "allMarkets" } },
      [
        _c("span", { staticClass: "fw-500" }, [_vm._v("$1599 ")]),
        _c("span", [_vm._v("per year ( Includes access to all Markets )")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _c("div", { staticClass: "service-info" }, [
          _c("span", { staticClass: "static-text" }, [
            _vm._v(
              "Includes access to Regulatory Reports for all available Markets"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 col-xs-12 txt-alg-rt select-mrkt" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._v("Select Markets (Up to 3 markets can be selected)"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-md-12 col-lg-12 col-sm-12" }, [
        _c("hr", { staticClass: "cnf-hr-line" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }